// extracted by mini-css-extract-plugin
export default {"greyTypography":"P_E9rmoeXVBq7JPYBLSt","labelTooltip":"FCI29lSkJxQ_wAIZRgjg","label":"APzV8rl2RwJC4qrQhABv","header":"ev3ohj79s7WFdvUI0XhX"};